const getFeatures = () => {
    try {
        return JSON.parse(localStorage.getItem('userFeatures') || '[]');
    } catch {
        return [];
    }
};

const useFeatures = () => {
    const features = getFeatures();
    const isSuperAdmin = features.includes('superadmin') || features.includes('all');
    // Empty features = legacy session or role without FirmRole yet (e.g. new Accountant) — allow all
    const hasAll = isSuperAdmin || features.length === 0;

    const hasFeature = (key) => {
        if (!key) return true;
        if (hasAll) return true;
        return features.includes(key);
    };

    return { features, hasFeature, isSuperAdmin };
};

export default useFeatures;
